import { manualNavStateType } from 'reducer/types';
import { ActionTypes }        from 'actions/types';


export const initialNavState: manualNavStateType = {
  manualOn:     false,
  manualInd:    0,
  manualVal:    '',
  manualSelect: 0,
  regEmail:     false,
  favoritClick: false,
  sendMessage:  false
}

const manualNavReducer = (state = initialNavState, action: ActionTypes) => {

  switch (action.type) {


//SET_LRS_STATE   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_MANUAL_NAV_STATE':
  {
    return {
        ...state,
        ...action.payload
    }
  }



// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};


export { manualNavReducer };


